import React, { useState } from "react";
import { Row } from "react-bootstrap";
import { CForm, CCol, CFormLabel, CFormFeedback, CFormInput, CButton } from "@coreui/react";
// import FormWrapper from "../../../pagecomponents/Common/FormWrapper";
import { checkEmpty, toastMessage } from "../../../helpers/utility.js";

const JobTypeAddEditForm = ({saveData, closeModal, formPayload, isSaveDisabled}) => {
    const [formData, setFormData] = useState(formPayload);
    const [validated, setValidated] = useState(false);

    const handleInputChange = (e) => {
        const {name, value} = e.target;
        
        // Check for special characters in customer_Name
        // if (name === "job_type_Name") {
        //     const isValid = value === "" || /^[a-zA-Z\s]+$/.test(value); // Allows only letters and spaces
        //     if (!isValid) {
        //         toastMessage("error", "Special characters are not allowed in the input.");
        //         return;
        //     }
        // }

        setFormData({...formData, [name] : value});
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.stopPropagation();
        } else {
            console.log(formData);
            saveData(formData);
        }
        setValidated(true);
    };

    return(
        <CForm
        className="g-3 needs-validation"
        noValidate
        validated={validated}
        onSubmit={handleSubmit}
        >
            <Row className="row-xs mb-2">
                <CCol md={12}>
                    <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="job_type_Name">Job Type Name</CFormLabel>
                    <CFormInput
                        type="text"
                        id="job_type_Name"
                        name="job_type_Name"
                        value={formData.job_type_Name}
                        onChange={handleInputChange}
                        required
                        // pattern="^[a-zA-Z\s]+$" // Ensures no special characters
                    />
                    <CFormFeedback invalid>Enter Job Type Name</CFormFeedback>
                </CCol>
            </Row>
            <Row className="row-xs mb-2 btn-animation">
                <CCol xs={12} className="mt-10">
                    {/* <CButton color="primary" className="btn btn-sm float-end" type="submit">Save Changes</CButton>
                    <CButton color="secondary" className="btn btn-sm float-end me-2" onClick={closeModal}>Close</CButton> */}
                    <CButton 
                        color="primary" 
                        className={`btn btn-sm float-end ${isSaveDisabled ? 'btn-loaders' : ''}`} 
                        type="submit"
                        disabled={isSaveDisabled}
                    >
                        {isSaveDisabled ? (<span className="loading">Save Changes</span>) : "Save Changes"}
                    </CButton>
                    <CButton color="secondary" className="btn btn-sm float-end me-2" onClick={closeModal} disabled={isSaveDisabled}>
                        Close
                    </CButton>
                </CCol>
            </Row>
        </CForm>
    );
};

export default JobTypeAddEditForm;